// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hu5M","controls":"styles_controls__1sCHW","charLimit":"styles_charLimit__16NWG","input":"styles_input__2RTMO","send":"styles_send__Ggj5A"};